import * as CONST from 'Reducers/Jobs/const'

/**
 * Upload a file
 * @param {File} file
 */
export const createJob = (jobParams, callbacks) => ({
  type: CONST.CREATE_JOB,
  jobParams,
  callbacks,
})



// WEBPACK FOOTER //
// ./src/Reducers/Jobs/actions.js